import { normalizeHref, uuid } from 'wix-rich-content-common';

const WIX_MEDIA_BASE_URL = "https://static.wixstatic.com/";
const WIX_VIDEO_BASE_URL = "https://video.wixstatic.com/";
const isAbsoluteUrl = (url) => url.startsWith("http://") || url.startsWith("https://");
const getAbsoluteUrl = (url, type) => {
  if (isAbsoluteUrl(url)) {
    return url;
  }
  let baseUrl, baseFolder;
  if (type === "image") {
    baseUrl = WIX_MEDIA_BASE_URL;
    baseFolder = "media/";
  } else {
    baseUrl = WIX_VIDEO_BASE_URL;
    baseFolder = "video/";
  }
  const pathWithFolder = url.startsWith(baseFolder) ? url : baseFolder + url;
  return baseUrl + pathWithFolder;
};

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const convertItemData = ({ items, anchorTarget, relValue }) => items.map((item, index) => {
  const { metadata, metaData } = item;
  if (metaData && item.mediaUrl) {
    return item;
  }
  const convertedData = {
    mediaUrl: item.url,
    metaData: {
      link: {
        type: "none",
        target: "_blank"
      }
    },
    directLink: {}
  };
  if (metadata) {
    convertedData.metaData = __spreadProps(__spreadValues({}, metadata), {
      link: {
        type: "none",
        target: "_blank"
      }
    });
    if (item.metadata.type === "video") {
      convertedData.metaData.link = {
        target: "_blank",
        rel: "noopener",
        url: normalizeHref(item.url || "")
      };
      const { pathname, thumbnail: { pathname: thumbPathname, width, height } = {} } = convertedData.metaData.poster || {};
      if (pathname && thumbPathname) {
        convertedData.metaData.poster = {
          url: getAbsoluteUrl(thumbPathname, "image"),
          width,
          height
        };
      } else if (typeof convertedData.metaData.poster === "string") {
        convertedData.metaData.poster = {
          url: convertedData.metaData.poster,
          width: convertedData.metaData.width,
          height: convertedData.metaData.height
        };
      }
    }
    convertedData.metaData.alt = metadata.altText;
    if (item.metadata.link) {
      convertedData.metaData.link = {
        type: "wix",
        target: item.metadata.link.target || anchorTarget || "_self",
        data: {
          type: "ExternalLink",
          target: item.metadata.link.target || anchorTarget || "_self",
          rel: item.metadata.link.rel || relValue || "noopener",
          url: normalizeHref(item.metadata.link.url || "")
        }
      };
      convertedData.directLink = {
        url: normalizeHref(item.metadata.link.url || ""),
        target: item.metadata.link.target || anchorTarget || "_self",
        rel: item.metadata.link.rel || relValue || "noopener"
      };
    }
  }
  uuid();
  return __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, item), {
    metadata: void 0
  }), convertedData), {
    // uuid is used to guarentee there are no 2 gallery items on the DOM with the same ID (on different galleries) due to a pro gallery issues with videos - it gives console errors and might also break the video controls behavoiur.
    // TODO: remove uuid when gallery fixes the issue \ release version 4.
    itemId: uuid() + "_" + index.toString(),
    hash: item.url + "_" + index.toString()
  });
});

export { convertItemData };
